/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'map': {
    width: 20,
    height: 22,
    viewBox: '0 0 20 22',
    data: '<g _fill="none" fill-rule="evenodd" _stroke="#606060" stroke-width="1.5"><path pid="0" stroke-linecap="square" d="M14 20l5-1.895V2l-5 1.895"/><path pid="1" d="M13 20l-6-1.895V2l6 1.895z"/><path pid="2" stroke-linecap="square" d="M6 2L1 3.895V20l5-1.895"/></g>'
  }
})
